import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import s from './Occasion.scss';
import Page from '../../components/Page';
import Grid from '../../components/Grid';
import Label from '../../components/Label';
import Slider from '../../components/Slider';
import Card from '../../components/Card';
import Link from '../../components/Link';
import { createMarkup } from '../../helpers';
import { occasionMessages as messages } from '../../defineMessages';
import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import { SHOP_PATH } from '../../constants';
import OccasionSkeleton from './OccasionSkeleton';

const Occasion = ({
  title,
  image,
  content,
  occasion: { data, loading },
  isDesktop,
  isTouchCapable,
  isSmallScreen,
}) => (
  <Page className={s.page}>
    {loading ? (
      <OccasionSkeleton />
    ) : (
      <div className={s.root}>
        <div className={s.banner}>
          <div className={s.image}>
            <img src={image && image[0].source} alt={title} />
          </div>
        </div>
        <div className={s.container}>
          <div className={s.heading}>
            <Label tag="h1" bold>
              {title}
            </Label>
            <Label tag="h2">
              <FormattedMessage {...messages.selectionOfOurGifts} />
            </Label>
          </div>

          <div className={s.content}>
            {data && data.length > 0 ? (
              <div className={cx(s['product-list'])}>
                {isDesktop ? (
                  <Grid container spacing="fluid" justify="center">
                    {data.map(product => (
                      <Grid item xs={12} sm={6} md={4} key={product.id}>
                        <Card
                          {...product}
                          hoverType="box-shadow"
                          productLogo={
                            product.productLogo &&
                            product.productLogo[0]?.thumbnail
                              ? product.productLogo[0].thumbnail
                              : ''
                          }
                          link={
                            <Link
                              to={`${SHOP_PATH}/${product.productSlug}/${product.id}`}
                            />
                          }
                        />
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Slider
                    naturalSlideHeight={100}
                    visibleSlides={isSmallScreen ? 3.3 : 2.3}
                    className={s.slider}
                    arrows={!isTouchCapable}
                    hoverArrows={!isTouchCapable}
                    isIntrinsicHeight
                  >
                    {data.map(product => (
                      <Card
                        key={product.id}
                        {...product}
                        productLogo={
                          product.productLogo &&
                          product.productLogo[0]?.thumbnail
                            ? product.productLogo[0].thumbnail
                            : ''
                        }
                        link={
                          <Link
                            to={`${SHOP_PATH}/${product.productSlug}/${product.id}`}
                          />
                        }
                      />
                    ))}
                  </Slider>
                )}
              </div>
            ) : (
              <Label>No Products</Label>
            )}
            <div
              className={s.description}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={createMarkup(content)}
            />
          </div>
        </div>
      </div>
    )}
  </Page>
);

Occasion.propTypes = {
  occasion: PropTypes.shape().isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  isDesktop: PropTypes.bool.isRequired,
  isTouchCapable: PropTypes.bool.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  content: PropTypes.string.isRequired,
};

const mapState = state => ({
  occasion: state.shop.occasion,
});

export default compose(
  connect(mapState),
  withStyles(s),
  withResponsiveWrapper(),
)(Occasion);
